import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PartnerForm, Event } from '../../../../interfaces';
import { PartnerApi } from '../../../../../assets/js/lb-sdk/services';
import { finalize } from 'rxjs/operators';
import { PARTNER_OBJECT_TYPE } from '../../../../enums';

@Component({
  selector: 'app-partner-identity-verification-form',
  templateUrl: './partner-identity-verification-form.component.html',
  styleUrls: ['./partner-identity-verification-form.component.css']
})
export class PartnerIdentityVerificationFormComponent implements OnInit {
  @Input() partner: PartnerForm;
  @Output() verify = new EventEmitter<Event>();
  PARTNER_OBJECT_TYPE: typeof PARTNER_OBJECT_TYPE = PARTNER_OBJECT_TYPE;

  constructor(
    private partnerApi: PartnerApi
  ) { }

  ngOnInit() { }

  submit(form) {
    if (form.valid) {
      this.verify.emit({ event: 'started' });
      this.partner.verifiedPartner = false;
      this.partnerApi
        .verify(
          this.partner.type,
          this.partner.partnerId,
          PARTNER_OBJECT_TYPE.MERCHANT !== this.partner.type ? {
              firstName: this.partner.firstName,
              lastName: this.partner.lastName
            } : {
              accountName: this.partner.firstName,
              accountName2: this.partner.lastName
            }
        )
        .pipe(finalize(() => {
          this.verify.emit({ event: 'ended' });
        }))
        .subscribe(
          type => {
            this.verify.emit({ event: 'success', data: type });
            this.partner.verifiedPartner = true;
          },
          error => {
            this.verify.emit({ event: 'failed', data: error.message });
          }
        );
    }
  }
}
